<div class="d-flex flex-column flex-md-row justify-content-md-between align-items-center">
  <h4 class="default-color strong my-4">{{ heading }}</h4>
  <div class="d-flex align-item-center">
    <ng-content></ng-content>
  </div>
</div>
